import { sanitizeName } from './sanitize-name'

// NAS 上 deliverable 层路径（相对 storage 根，无尾部斜线）：
//   <projectPath>/6_Export/<deliverableName>
// projectPath 由用户配置，仅去掉尾部分隔符后原样使用。
export const buildNasDeliverablePath = (projectPath: string, deliverableName: string): string =>
  `${projectPath.replace(/[\\/]+$/, '')}/6_Export/${sanitizeName(deliverableName)}`
